<template>
  <div>
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="yuyue">
      <div class="bg1 pc" style="padding: 30px 0">
        <div
          id="yuyuefangshi"
          class="main-content"
          style="background: #fff; margin: 0 auto; padding: 20px 0"
        >
          <div
            class="list-tit"
            style="margin-bottom: 20px; margin: 0 40px 20px"
          >
            <div style="font-size: 20px">
              <span>快速挂号</span>
            </div>
          </div>
          <div style="width: 70%; margin: 10px auto">
            <div v-if="detail.content && detail.content !== ''">
              <div class="list-tit" style="margin-bottom: 20px">
                <div>
                  <span>预约方式</span>
                </div>
              </div>
              <div v-html="detail.content"></div>
            </div>
            <div
              style="
                margin-top: 20px;
                box-shadow: -5px 6px 25px -12px rgb(0 0 0 / 75%);
                padding: 10px 20px;
                border-radius: 5px;
              "
            >
              <!-- <div style="text-align: center;margin-bottom:20px;font-size:20px;">快速挂号</div> -->
              <div class="list-tit" style="margin-bottom: 20px">
                <div>
                  <span>预约挂号</span>
                </div>
              </div>
              <div>
                <div
                  style="font-size: 14px; margin-bottom: 16px; color: #439392"
                >
                  预约挂号让看病更方便，黄家圣幸中医医院全心为您服务，祝您早日康复！
                </div>
                <el-form label-width="120px">
                  <el-form-item label="姓名：">
                    <el-input
                      v-model="form.name"
                      style="width: 50%"
                      placeholder="请输入姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="身份证号码：">
                    <el-input
                      v-model="form.card_id"
                      style="width: 50%"
                      placeholder="请输入身份证号码"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="电话：">
                    <el-input
                      v-model="form.mobile"
                      style="width: 50%"
                      placeholder="请输入电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="预约日期：">
                    <el-date-picker
                      v-model="form.subscribe_time"
                      style="width: 50%"
                      value-format="timestamp"
                      placeholder="请选择预约日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="病情描述：">
                    <el-input
                      v-model="form.describe"
                      style="width: 100%"
                      type="textarea"
                      :rows="5"
                      placeholder="请输入病情描述"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div>
                  <verification
                    :key="verificationkey3"
                    ref="verification1"
                    style="margin-top: 20px; width: 300px; margin-left: 120px"
                  ></verification>
                </div>
                <el-button
                  style="
                    background: #439392;
                    color: #fff;
                    font-size: 16px;
                    height: 40px;
                    line-height: 40px;
                    width: 130px;
                    border-radius: 0;
                    padding: 0;
                    margin-top: 20px;
                    margin-left: 120px;
                  "
                  @click="submit('pc')"
                  >提 交</el-button
                >
              </div>
            </div>

            <div
              style="
                margin-top: 20px;
                box-shadow: -5px 6px 25px -12px rgb(0 0 0 / 75%);
                padding: 10px 20px;
                border-radius: 5px;
              "
              v-if="detail.min_content"
            >
              <!-- <div style="text-align: center;margin-bottom:20px;font-size:20px;">快速挂号</div> -->
              <div class="list-tit" style="margin-bottom: 20px">
                <div>
                  <span>注意事项</span>
                </div>
              </div>
              <div>
                <div
                  style="font-size: 14px; margin-bottom: 16px; color: #666"
                  v-html="detail.min_content"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile">
        <div
          id="yuyuefangshi"
          class="main-content"
          style="background: #f3f3f3; margin: 0 auto; padding: 20px 0"
        >
          <div class="mobileTitle">快速挂号</div>
          <div style="width: 100%; margin: 10px auto">
            <div
              v-if="detail.content && detail.content !== ''"
              style="padding: 10px; background: #fff"
            >
              <div class="list-tit" style="margin-bottom: 20px">
                <div>
                  <span>预约方式</span>
                </div>
              </div>
              <div v-html="detail.content"></div>
            </div>
            <div
              style="
                background: #fff;
                padding: 10px;
                margin-top: 10px;
                border-radius: 5px;
              "
            >
              <!-- <div style="text-align: center;margin-bottom:20px;font-size:20px;">快速挂号</div> -->
              <div class="list-tit" style="margin-bottom: 20px">
                <div>
                  <span>预约挂号</span>
                </div>
              </div>
              <div>
                <div
                  style="font-size: 14px; margin-bottom: 16px; color: #763a27"
                >
                  预约挂号让看病更方便，黄家圣幸中医医院全心为您服务，祝您早日康复！
                </div>
                <el-form>
                  <el-form-item>
                    <el-input
                      v-model="form.name"
                      style="width: 100%"
                      placeholder="请输入姓名"
                    >
                      <template slot="prepend">
                        <img
                          src="../../assets/icon6.png"
                          style="width: 18px; background: #fff"
                          alt=""
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.card_id"
                      style="width: 100%"
                      placeholder="请输入身份证号码"
                    >
                      <template slot="prepend">
                        <img
                          src="../../assets/icon11.png"
                          style="width: 18px; background: #fff"
                          alt=""
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.mobile"
                      style="width: 100%"
                      placeholder="请输入电话"
                    >
                      <template slot="prepend">
                        <img
                          src="../../assets/icon7.png"
                          style="width: 18px; background: #fff"
                          alt=""
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div class="flex-center">
                      <div
                        style="
                          padding: 0 0.1rem;
                          background: #f5f7fa;
                          border: 1px solid #dcdfe6;
                        "
                      >
                        <img
                          src="../../assets/icon12.png"
                          style="width: 18px; background: #fff"
                          alt=""
                        />
                      </div>
                      <div
                        @click="showPicker = true"
                        style="
                          flex: 1;
                          background: #fff;
                          height: 40px;
                          line-height: 40px;
                          border: 1px solid #e5e5e5;
                          padding: 0 0.15rem;
                        "
                      >
                        {{ form.subscribe_time || "" }}
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.describe"
                      style="width: 100%"
                      type="textarea"
                      :rows="5"
                      placeholder="请输入病情描述"
                    >
                      <template slot="prepend">
                        <img
                          src="../../assets/icon12.png"
                          style="width: 18px; background: #fff"
                          alt=""
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="" style="margin-top: 20px">
                  <verification
                    :key="verificationkey4"
                    ref="verification2"
                    style="
                      width: 3.2rem;
                      font-size: 14px;
                      zoom: 1;
                      margin: 0 auto;
                    "
                    type="mobile"
                  ></verification>
                  <div
                    style="
                      background: #763a27;
                      color: #fff;
                      font-size: 16px;
                      height: 40px;
                      line-height: 40px;
                      margin: 0 auto;
                      width: 3.2rem;
                      border-radius: 0;
                      text-align: center;
                      border-radius: 2px;
                      padding: 0;
                      margin-top: 20px;
                    "
                    @click="submit('mobile')"
                  >
                    提 交
                  </div>
                </div>
              </div>
            </div>

            <div
              style="
                background: #fff;
                padding: 10px;
                margin-top: 10px;
                padding: 10px 20px;
                border-radius: 5px;
              "
              v-if="detail.min_content"
            >
              <!-- <div style="text-align: center;margin-bottom:20px;font-size:20px;">快速挂号</div> -->
              <div class="list-tit" style="margin-bottom: 20px">
                <div>
                  <span>注意事项</span>
                </div>
              </div>
              <div>
                <div
                  style="font-size: 14px; margin-bottom: 16px; color: #666"
                  v-html="detail.min_content"
                ></div>
              </div>
            </div>
          </div>
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
              v-model="subscribe_time"
              type="date"
              title="选择预约时间"
              :min-date="minDate"
              @confirm="confirm"
              @cancel="showPicker = false"
            />
          </van-popup>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import { getmenudetail, addsubscribe, guidedetail } from "@/api/common";
import verification from "@/components/verification";
export default {
  name: "yuyue",
  components: { banner, footerBar, headerBar, verification },
  data() {
    return {
      form: {
        name: "",
        card_id: "",
        mobile: "",
        subscribe_time: "",
        describe: "",
      },
      verificationkey4: false,
      verificationkey3: false,
      subscribe_time: new Date(),
      minDate: new Date(),
      showPicker: false,
      activeIndex: "news",
      info: { carousel: "", Mcarousel: "" },
      detail: {},
    };
  },
  mounted() {
    // console.log(this.$route.query)
    // this.goAuchor('#'+this.$route.query.id)
    getmenudetail({ id: 8 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });

    guidedetail({ id: 3 }).then((res) => {
      this.detail = res.data[0];
    });
  },
  methods: {
    goAuchor(id) {
      document.querySelector(id).scrollIntoView(true);
      var auchor = this.$el.querySelector(id);
      document.body.scrollTop = auchor.offsetTop;
    },
    submit(type) {
      if (this.form.name === "") {
        this.$notify({
          title: "姓名不能为空",
          type: "error",
        });
        return;
      }
      if (this.form.card_id === "") {
        this.$notify({
          title: "身份证号码不能为空",
          type: "error",
        });
        return;
      }
      if (this.form.mobile === "") {
        this.$notify({
          title: "电话不能为空",
          type: "error",
        });
        return;
      }
      if (this.form.subscribe_time === "") {
        this.$notify({
          title: "预约日期不能为空",
          type: "error",
        });
        return;
      }
      if (this.form.describe === "") {
        this.$notify({
          title: "病情描述不能为空",
          type: "error",
        });
        return;
      }
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(this.form.card_id) === false) {
        this.$notify({
          title: "身份证号码有误，请重新输入",
          type: "error",
        });
        return;
      }
      var phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (phoneReg.test(this.form.mobile) === false) {
        this.$notify({
          title: "手机号有误，请重新输入",
          type: "error",
        });
        return;
      }

      if (type === "pc" && this.$refs.verification1.confirmSuccess == false) {
        this.$notify.error(`请完成拖动滑块验证`);
        return;
      }
      if (
        type === "mobile" &&
        this.$refs.verification2.confirmSuccess == false
      ) {
        this.$notify.error(`请完成拖动滑块验证`);
        return;
      }
      if (type === "pc") {
        if (
          this.form.subscribe_time !== undefined &&
          this.form.subscribe_time !== "" &&
          this.form.subscribe_time !== null
        ) {
          this.form.subscribe_time = String(this.form.subscribe_time).slice(
            0,
            10
          );
        }
      }
      if (type === "mobile") {
        if (
          this.form.subscribe_time !== undefined &&
          this.form.subscribe_time !== "" &&
          this.form.subscribe_time !== null
        ) {
          this.form.subscribe_time = String(
            Number(new Date(this.form.subscribe_time))
          ).slice(0, 10);
        }
      }
      addsubscribe(this.form).then((res) => {
        this.form = {
          name: "",
          card_id: "",
          mobile: "",
          subscribe_time: "",
          department1: "",
          doctor1: "",
          describe: "",
        };
        this.$notify({
          type: "success",
          message: "挂号成功",
        });
          this.verificationkey4 = !this.verificationkey4
          this.verificationkey3 = !this.verificationkey3
      });
    },
    confirm(value) {
      console.log(value);
      this.form.subscribe_time = this.parseTime(value, "{y}-{m}-{d}");
      this.showPicker = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/views/news/yuyue.vue